<template>
  <div class="filter-wrapper">
    <el-collapse accordion class="filter-collapse">
      <el-collapse-item name="1">
        <template #title>
          <div class="filter-title">
            <el-icon class="filter-icon"><Filter /></el-icon>
            <span class="filter-text">Filtra risultati</span>
          </div>
        </template>

        <div class="filter-grid">
          <div class="filter-item">
            <label class="filter-label">Nome e cognome cliente</label>
            <el-input
              v-model="nome"
              placeholder="Cerca cliente..."
              clearable
              class="filter-input"
            >
              <template #prefix>
                <el-icon><User /></el-icon>
              </template>
            </el-input>
          </div>

          <div class="filter-item">
            <label class="filter-label">Targa</label>
            <el-input
              v-model="targa"
              placeholder="Cerca targa..."
              clearable
              class="filter-input"
            >
              <template #prefix>
                <el-icon><Van /></el-icon>
              </template>
            </el-input>
          </div>

          <div class="filter-item">
            <label class="filter-label">Data booking</label>
            <el-date-picker
              v-model="data"
              type="date"
              placeholder="Seleziona data"
              format="DD/MM/YYYY"
              value-format="YYYY-MM-DD"
              class="filter-date"
              clearable
            />
          </div>

          <div class="filter-item">
            <label class="filter-label">Servizio</label>
            <el-cascader
              v-model="servizio"
              :options="servizi"
              placeholder="Seleziona servizio"
              clearable
              class="filter-cascader"
            />
          </div>

          <div class="filter-item filter-actions">
            <el-button type="primary" @click="handleButtonClick">
              <el-icon><Refresh /></el-icon>
              Reset filtri
            </el-button>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { Filter, User, Van, Refresh } from '@element-plus/icons-vue';

export default {
  components: {
    Filter,
    User,
    Van,
    Refresh,
  },
  props: {
    servizi: {
      required: true
    }
  },
  data() {
    return {
      nome: '',
      targa: '',
      servizio: '',
      data: ''
    };
  },
  watch: {
    nome(val) {
      this.$emit('nomeChanged', val);
    },
    targa(val) {
      this.$emit('targaChanged', val);
    },
    servizio(val) {
      this.$emit('servizioChanged', val);
    },
    data(val) {
      this.$emit('dataChanged', val);
    },
  },
  methods: {
    handleButtonClick() {
      this.$emit('resetClick');
    }
  }
};
</script>

<style scoped>
.filter-wrapper {
  margin-bottom: 16px;
}

.filter-collapse :deep(.el-collapse-item__header) {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 0 20px;
  height: 56px;
  border: 1px solid #E5E5E5;
}

.filter-collapse :deep(.el-collapse-item__wrap) {
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-top: none;
  border-radius: 0 0 12px 12px;
}

.filter-collapse :deep(.el-collapse-item__content) {
  padding: 20px;
}

.filter-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-icon {
  font-size: 18px;
  color: #4B30F2;
}

.filter-text {
  font-size: 0.95rem;
  font-weight: 600;
  color: #171717;
}

.filter-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  align-items: end;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #525252;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.filter-input,
.filter-date,
.filter-cascader {
  width: 100%;
}

.filter-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
}

.filter-actions .el-button {
  height: 40px;
}

/* Responsive */
@media (max-width: 768px) {
  .filter-grid {
    grid-template-columns: 1fr;
  }

  .filter-actions {
    margin-top: 8px;
  }

  .filter-actions .el-button {
    width: 100%;
  }
}
</style>
